import { render, staticRenderFns } from "./DialogReportHistory.vue?vue&type=template&id=2fb41658&scoped=true&"
import script from "./DialogReportHistory.vue?vue&type=script&lang=js&"
export * from "./DialogReportHistory.vue?vue&type=script&lang=js&"
import style0 from "./DialogReportHistory.vue?vue&type=style&index=0&id=2fb41658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb41658",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fb41658')) {
      api.createRecord('2fb41658', component.options)
    } else {
      api.reload('2fb41658', component.options)
    }
    module.hot.accept("./DialogReportHistory.vue?vue&type=template&id=2fb41658&scoped=true&", function () {
      api.rerender('2fb41658', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogReportHistory.vue"
export default component.exports